import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChatCommentComponent } from '@shared/modules/comments/components/chat-comment/chat-comment.component';
import { IsMeModule } from '@shared/modules/comments/components/pipes/is-me/is-me.module';
import { BbcodeModule } from '@shared/modules/comments/components/pipes/bbcode/bbcode.module';
import { AutolinkModule } from '@shared/modules/comments/components/pipes/autolink/autolink.module';
import { ChatCommentAttachmentModule } from '@shared/modules/files/components/chat-comment-attachment/chat-comment-attachment.module';
import { IconModule } from '@shared/modules/common/icon/icon.module';
import { ReplaceDeeplinksModule } from '@shared/modules/comments/components/pipes/replace-deeplinks/replace-deeplinks.module';
import { IsEmojiPipe } from '@shared/modules/comments/components/chat-comment/internal/is-emoji.pipe';
import { DropdownModule } from '@shared/ui/dropdown/dropdown.module';
import { LoopTooltipModule } from '@shared/ui/tooltip/tooltip.module';
import { FancyDateModule } from '@shared/shared/fancy-date/shell/fancy-date.module';
import { IncludesPipe } from '@shared/ui/pipes/includes.pipe';
import { ContactAvatarModule } from '@shared/modules/contacts/components/contact-avatar/contact-avatar.module';
import { LoopEmojiDirective } from '@shared/ui/emoji/directives/emoji.directive';
import { AtomModule } from '@shared/modules/color-scheme/atom/atom.module';
import { CommentReactionsComponent } from '@shared/modules/comments/components/comment-reactions/comment-reactions.component';
import { HasReactionsPipe } from '@shared/modules/comments/components/comment-reactions/internal/has-reactions.pipe';
import { GetReactionTagsPipe } from '@shared/modules/comments/components/comment-reactions/internal/get-reaction-tags.pipe';
import { LoaderNewComponent } from '@shared/ui/loader/loader-new.component';
import { SafeModule } from '@dta/ui/pipes/safe/safe.module';
import { UserNameModule } from '@dta/ui/pipes/user-name/user-name.module';
import { TimeAgoModule } from '@dta/ui/components/common/time-ago/time-ago.module';
import { LoaderModule } from '@dta/ui/components/common/loader/loader.module';
import { IsCommentDeletedPipe } from './internal/is-comment-deleted.pipe';

@NgModule({
  declarations: [ChatCommentComponent, IsCommentDeletedPipe, IsEmojiPipe],
  imports: [
    CommonModule,
    IsMeModule,
    BbcodeModule,
    AutolinkModule,
    SafeModule,
    UserNameModule,
    ChatCommentAttachmentModule,
    TimeAgoModule,
    IconModule,
    ReplaceDeeplinksModule,
    DropdownModule,
    LoopTooltipModule,
    FancyDateModule,
    IncludesPipe,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    ContactAvatarModule,
    LoopEmojiDirective,
    AtomModule,
    LoaderModule,
    LoaderNewComponent,
    HasReactionsPipe,
    GetReactionTagsPipe,
    CommentReactionsComponent
  ],
  exports: [ChatCommentComponent]
})
export class ChatCommentModule {}
